import { useTranslation } from "next-i18next";
import { FieldValues, SubmitHandler } from "react-hook-form";
import { FC } from "react";
import { GenericForm } from "@components/commun";
import { Button } from "@components/ui";
import { FormPreProps } from "@middleware/types";

interface Props {
  filter: (word: string) => void;
}

export const SearchForm: FC<Props> = ({ filter }) => {
  const { t } = useTranslation();

  const onSubmit: SubmitHandler<FieldValues> = async (datas) => {
    filter(datas.filter);
  };

  const renderForm = ({ register, isSubmitting }: FormPreProps) => {
    return (
      <div className="lk-flex space-between">
        <input
          className="input-text "
          type="text"
          {...register("filter")}
          placeholder={t("pages.enterQuestion")}
        />

        <Button type="submit" disabled={isSubmitting} variant="default">
          {t("buttons.search")}
        </Button>
      </div>
    );
  };

  return <GenericForm renderForm={renderForm} onSubmitForm={onSubmit} />;
};
